import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatCurrency(value, currency = "BRL") {
  return new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: currency,
  }).format(value || 0);
}

export function formatNumber(value, decimals = 0) {
  return new Intl.NumberFormat("pt-BR", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(value || 0);
}

export function formatPercent(value) {
  return new Intl.NumberFormat("pt-BR", {
    style: "percent",
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
  }).format((value || 0) / 100);
}

export function formatDate(dateString) {
  if (!dateString) return "-";
  const date = new Date(dateString);
  return new Intl.DateTimeFormat("pt-BR").format(date);
}

export function formatDateTime(dateString) {
  if (!dateString) return "-";
  const date = new Date(dateString);
  return new Intl.DateTimeFormat("pt-BR", {
    dateStyle: "short",
    timeStyle: "short",
  }).format(date);
}

export function getStatusClass(status) {
  const statusMap = {
    pendente: "status-pendente",
    recebido: "status-recebido",
    pago: "status-pago",
    parcial: "status-parcial",
    atrasado: "status-atrasado",
    vencido: "status-vencido",
    aberta: "status-aberta",
    em_andamento: "status-em_andamento",
    concluida: "status-concluida",
    cancelada: "status-cancelada",
    ativo: "status-recebido",
    inativo: "status-cancelada",
  };
  return statusMap[status] || "bg-gray-100 text-gray-700";
}

export function getPriorityClass(priority) {
  const priorityMap = {
    baixa: "prioridade-baixa",
    media: "prioridade-media",
    alta: "prioridade-alta",
    urgente: "prioridade-urgente",
  };
  return priorityMap[priority] || "prioridade-media";
}

export function getStatusLabel(status) {
  const labels = {
    pendente: "Pendente",
    recebido: "Recebido",
    pago: "Pago",
    parcial: "Parcial",
    atrasado: "Atrasado",
    vencido: "Vencido",
    aberta: "Aberta",
    em_andamento: "Em Andamento",
    aguardando_terceiro: "Aguardando",
    concluida: "Concluída",
    cancelada: "Cancelada",
    ativo: "Ativo",
    inativo: "Inativo",
    emitida: "Emitida",
  };
  return labels[status] || status;
}

export function getPriorityLabel(priority) {
  const labels = {
    baixa: "Baixa",
    media: "Média",
    alta: "Alta",
    urgente: "Urgente",
  };
  return labels[priority] || priority;
}

export function truncate(str, length = 50) {
  if (!str) return "";
  return str.length > length ? str.substring(0, length) + "..." : str;
}

export function generateId() {
  return Math.random().toString(36).substring(2, 9);
}

export function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}
